export default class Service {
    baseUrl = '/ajax.php';
}
